import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=6007faf8&"
import script from "./VForm.vue?vue&type=script&lang=js&"
export * from "./VForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports